import Vue from 'vue'

export function createToastNotification (message, options) {
  Vue.$toast.open({
    message,
    ...options
  })
}
